import { render, staticRenderFns } from "./UserTask.vue?vue&type=template&id=22d34fce&scoped=true&"
import script from "./UserTask.vue?vue&type=script&lang=js&"
export * from "./UserTask.vue?vue&type=script&lang=js&"
import style0 from "./UserTask.vue?vue&type=style&index=0&id=22d34fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d34fce",
  null
  
)

export default component.exports